<!-- <div>
<i nz-icon nzType="folder" nzTheme="twotone" class="header-icon"></i>&nbsp;<b class="header-label">Create Help videos</b>
</div> -->
<pg-header
  title="Create Help videos"
  ticon="folder"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div class="m-24">
    <div>
      <div>
        <div class="input-row" nz-row>
          <div nz-col nzXs="16" nzSm="16" nzMd="6" nzLg="6" nzXl="11">
            <div class="inptLbl">video Groups</div>
            <nz-select
              required
              [(ngModel)]="selectedGroupId"
              (ngModelChange)="onvideoGrpSelection()"
            >
              @for (vg of videogrps; track vg) {
              <nz-option [nzValue]="vg.vdo_grp_id" [nzLabel]="vg.vdo_grp_nm">
              </nz-option>
              }
            </nz-select>
          </div>
        </div>
      </div>
    </div>
    @if ((permissions.slct_in==1)?true:false) {
    <div nz-row class="gridTop">
      @if (loader) {
      <ds-loading></ds-loading>
      }
      <div class="ds-card grid">
        <app-data-grid
          id="gridContainer"
          class="p-8"
          style="width: 100%"
          [dataSource]="rowData"
          [legacyColumns]="columnDefs"
          [searchPanel]="true"
          [filterRow]="true"
          [filterPanel]="true"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
          exportFileName="Change Log"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
        >
          <app-grid-column
            [showInColumnChooser]="false"
            [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
            type="buttons"
            [width]="100"
            caption="Edit"
            cellTemplate="editTemplate"
          ></app-grid-column>
          <ng-template appGridCell="editTemplate" let-data="cell"
            ><div>
              <div class="tblEdtBtn" (click)="onEdit2(data)">Edit</div>
            </div></ng-template
          >
          <app-grid-column
            [showInColumnChooser]="false"
            [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
            type="buttons"
            [width]="100"
            caption="Delete"
            cellTemplate="delTemplate"
          ></app-grid-column>
          <ng-template appGridCell="delTemplate" let-data="cell"
            ><div>
              <div class="tblDelBtn" (click)="onDelete2(data)">Delete</div>
            </div></ng-template
          >
        </app-data-grid>
      </div>
    </div>
    }
  </div>
  <nz-drawer
    [nzBodyStyle]="{ overflow: 'auto' }"
    [nzMaskClosable]="true"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    nzTitle="Create new page"
    (nzOnClose)="closeSideBar()"
  >
    <form nz-form [formGroup]="validateForm">
      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="8">video Name</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <input formControlName="vdo_nm" nz-input placeholder="please enter video name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="8">video embedded url</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <input formControlName="vdo_embd_tx" nz-input placeholder="please enter Answer" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="8">video description</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <input formControlName="vdo_dscn_tx" nz-input placeholder="please enter Answer" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="8">video thumbline image url</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <input formControlName="thmbl_imge_url_tx" nz-input placeholder="please enter Answer" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="8">Select Group</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <nz-select required nzPlaceHolder="Select Type" formControlName="vdo_grp_id">
            <nz-option *ngFor="let v of videogrps" [nzValue]="v.vdo_grp_id" [nzLabel]="v.vdo_grp_nm">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item> -->
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="mnuprflMrgn"
        >
          <nz-form-item>
            <nz-form-control>
              <div class="inptLbl">video Name</div>
              <input
                formControlName="vdo_nm"
                nz-input
                placeholder="please enter video name"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="mnuprflMrgn"
        >
          <nz-form-item>
            <nz-form-control>
              <div class="inptLbl">video embedded url</div>
              <input
                formControlName="vdo_embd_tx"
                nz-input
                placeholder="please enter Answer"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="mnuprflMrgn"
        >
          <nz-form-item>
            <nz-form-control>
              <div class="inptLbl">video description</div>
              <input
                formControlName="vdo_dscn_tx"
                nz-input
                placeholder="please enter Answer"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="mnuprflMrgn"
        >
          <nz-form-item>
            <nz-form-control>
              <div class="inptLbl">video thumbline image url</div>
              <input
                formControlName="thmbl_imge_url_tx"
                nz-input
                placeholder="please enter Answer"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="mnuprflMrgn"
        >
          <div class="inptLbl">Select Group</div>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                required
                nzPlaceHolder="Select Type"
                formControlName="vdo_grp_id"
              >
                @for (v of videogrps; track v) {
                <nz-option [nzValue]="v.vdo_grp_id" [nzLabel]="v.vdo_grp_nm">
                </nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div style="float: right">
        <button nz-button style="margin-right: 8px" (click)="closeSideBar()">
          Cancel
        </button>
        @if (!editClicked) {
        <button
          nz-button
          nzType="primary"
          (click)="submit()"
          [disabled]="!validateForm.valid"
        >
          Submit
        </button>
        } @if (editClicked) {
        <button
          nz-button
          nzType="primary"
          (click)="update()"
          [disabled]="!validateForm.valid"
        >
          Save
        </button>
        }
      </div>
    </form>
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
